
import ClickOutside from "vue-click-outside";

export default {
	name: "DesktopNavigationEntry",
	directives: {
		ClickOutside,
	},
	props: {
		entry: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			menuData: {},
		};
	},
	computed: {
		isInternalLink() {
			return this.entry.useRouter;
		},
	},
	created() {
		this.menuData = this.entry;
	},
	methods: {
		onLinkClick() {
			this.dispatchGaEvent();
		},
		onButtonClick() {
			if (typeof this.menuData.submenuIsOpen === "boolean") {
				this.menuData.submenuIsOpen = !this.menuData.submenuIsOpen;
			}
			this.dispatchGaEvent();
		},
		onNavItemClickOutside() {
			if (typeof this.menuData.submenuIsOpen === "boolean") {
				this.menuData.submenuIsOpen = false;
			}
		},
		onSubmenuLinkClick(item) {
			this.dispatchGaEvent(item);
			this.onNavItemClickOutside();
		},
		dispatchGaEvent(item = this.menuData) {
			const eventCategory = "Header";
			const eventLabel = item.label;
			const eventActionTranslation = item.gaEventAction || item.label;
			const eventAction = `Click on ${eventActionTranslation} navigation element`;
			this.$store.dispatch("tracking/trackEvent", {
				eventCategory,
				eventAction,
				eventLabel,
			});
		},
	},
};
